
import {
  computed, defineComponent, reactive,
} from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';

export default defineComponent({
  name: 'SelecionarGenericoString',
  components: {
  },
  props: {
    itens: {
      type: Array as () => IOptionString[],
      required: true,
    },
    varios: {
      type: Boolean,
      default: false,
    },
    valor: {
      type: String || undefined,
    },
    valoresSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
    limparSelecao: {
      type: Boolean,
      default: true,
    },
    mostrarBusca: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:valor', 'update:valoresSelecionados', 'change'],
  setup(props, { emit }) {
    const state = reactive({});

    function obterItem():any {
      return (props.valor === '' ? undefined : props.valor);
    }
    const computedValor = computed({
      get: () => obterItem(),
      set: (valor: string) => {
        emit('update:valor', valor);
      },
    });

    const computedValoresSelecionados = computed({
      get: () => props.valoresSelecionados,
      set: (valores: string[]) => {
        emit('update:valoresSelecionados', valores);
      },
    });

    function defineValorSelecionado(valor:string) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValoresSelecionados(valores:string[]) {
      emit('update:valoresSelecionados', valores);
      emit('change', valores);
    }

    function defineValorMarcado(valor:string) {
      emit('change', valor);
    }

    return {
      props,
      state,
      computedValor,
      computedValoresSelecionados,
      defineValorSelecionado,
      defineValoresSelecionados,
      defineValorMarcado,
    };
  },
});
